import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles.css';
import App from './App';
import { UserProvider } from './context/UserContext';
import { ToastProvider } from './components/Toast';
import { ConfirmProvider } from './components/ConfirmDialog';
import { SyncProvider } from './sync/SyncProvider';
import * as serviceWorker from './serviceWorkerRegistration';
import { applyEngineFlagFromUrl } from './engine/engineFlag';
import { startAnalyticsIfAllowed } from './analytics';
import { installErrorReporting } from './errorReporting';
import { installDiagnostics } from './diagnostics';
import ErrorBoundary from './components/ErrorBoundary';

applyEngineFlagFromUrl();
startAnalyticsIfAllowed();
installErrorReporting();
installDiagnostics();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <UserProvider>
        <ToastProvider>
            <ConfirmProvider>
                <ErrorBoundary>
                    <SyncProvider>
                        <App />
                    </SyncProvider>
                </ErrorBoundary>
            </ConfirmProvider>
        </ToastProvider>
    </UserProvider>
);

serviceWorker.register();
